import { getTestIds } from 'seagull/utils/TestIds';
export const emptyResponseData = ()=>({
        canUndo: false,
        isClarification: false,
        conversationId: '',
        output: null,
        clarificationText: null
    });
export const GetHelpMeWriteDrawerTID = (parentTestId)=>getTestIds(parentTestId);
